import { Popover } from 'antd';
import Button from 'components/Button';
import Text from 'components/Text';
import { listServicesColorSets } from 'features/settingService/pages/SettingPage/components/ServicesSettingV2/ServicePart/PopoverChangeColors';
import settingApis from 'features/settingService/services/apis';
import { useState } from 'react';
import { getMessageError, IResponseDataBody } from 'services/response';
import shopActions from 'services/shop/actions';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
import toast from 'utils/toast';

interface ChangeColorButtonProps {
  catId: string;
}

const ColorContent = ({ onChange }: { onChange: (value: string) => void }) => {
  return (
    <Content>
      <Text variant='CONTENT_2'>Change Color</Text>
      <div className='color_set'>
        {listServicesColorSets.map((o) => (
          <button
            onClick={() => onChange(o.value)}
            type='button'
            key={o.value}
            className='grid-item'
            style={{ background: o.style.bg, borderColor: o.style.stroke }}
          ></button>
        ))}
      </div>
    </Content>
  );
};

const ChangeColorButton = ({ catId }: ChangeColorButtonProps) => {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const onChooseColorSet = async (color: string) => {
    try {
      const res: IResponseDataBody = await settingApis.changeBackgroundColorsByCategory({
        id: catId,
        colorBackground: color,
      });

      if (res?.data?.data) {
        toast.success('Change color successfully');
        dispatch(shopActions.get.productCategories.fetch());
      }
    } catch (error) {
      toast.error(getMessageError(error) || 'Change color failed');
    }
    setOpen(false);
  };

  return (
    <Popover
      onOpenChange={setOpen}
      open={open}
      trigger={['click']}
      content={<ColorContent onChange={onChooseColorSet} />}
    >
      <Button ntype='PRIMARY' icon='paintColor'>
        Change Color
      </Button>
    </Popover>
  );
};

export default ChangeColorButton;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  .color_set {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    gap: 8px;
  }
  button.grid-item {
    width: 70px;
    height: 60px;
    border-radius: 4px;
    border-width: 3px;
    border-style: solid;
    &:hover {
      opacity: 0.8;
      cursor: pointer;
    }
  }
`;
